export default {
  settings: '个人设置',
  about: '关于',
};
